<template>
    <div class="apprentice-simple-card files-management">
        <div
            class="row"
            v-if="$authUser.isAdmin()">
            <div class="col-12">{{ $t('common.editor_type') }}: {{ this.editor_type }}</div>
        </div>

        <design-2021-apprentice-data-table
            class="group-options-table"
            nosearch
            striped
            responsive="md"
            stacked="sm"
            hover
            :items="optionItems"
            :fields="optionsFields"
            :custom-per-page="99">
            <template #head(choice)="data">
                <div class="choice-header">{{ data.label }}</div>
            </template>

            <template v-slot:cell(custom_name)="data">
                <design-2021-group-show-option-name-component
                    v-if="data.item.custom_name !== undefined"
                    :group-id="groupIn.id"
                    :name-in="data.item.custom_name"
                    :option-in="data.item.key"
                    :disabled="data.item.custom_name_disabled">
                </design-2021-group-show-option-name-component>
            </template>

            <template v-slot:cell(toggle)="data">
                <b-form-checkbox
                    v-model="data.item.switch_value"
                    name="group-management-choice-toggle"
                    @change="saveOption(data.item.key, $event)"
                    :disabled="data.item.disabled"
                    switch></b-form-checkbox>
            </template>
            <template v-slot:cell(choice)="data">
                <div
                    class="choice-wrapper"
                    v-if="data.item.hasChoice && (!data.item.disabled || data.item.key === 'document')">
                    <div
                        class="document-options"
                        v-if="data.item.key === 'document' && data.item.switch_value && groupIn.editor_type !== 'mg'">
                        <b-button
                            class="btn-file-alt"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :href="editorUrl"
                            target="_blank"
                            :title="$t('group.settings.set_up_text')">
                        </b-button>

                        <b-button
                            class="btn-upload"
                            v-b-modal="'paper-blueprint-upload-modal'"
                            variant="primary-icon-only">
                        </b-button>
                        <design-2021-group-show-upload-paper-blueprint-modal-component :id="groupIn.id">
                        </design-2021-group-show-upload-paper-blueprint-modal-component>
                    </div>

                    <div
                        class="actionplan-options"
                        v-if="data.item.key === 'actionplan' && data.item.switch_value">
                        <b-button
                            class="btn-file-alt btn-sm btn-primary"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :href="actionPlanUrl"
                            target="_blank"
                            :title="$t('group.settings.set_up_text')">
                        </b-button>

                        <b-button
                            class="btn-upload"
                            v-b-modal="'paper-actionplan-upload-modal'"
                            variant="primary-icon-only">
                        </b-button>
                        <design-2021-group-show-upload-actionplan-blueprint-modal-component :id="groupIn.id">
                        </design-2021-group-show-upload-actionplan-blueprint-modal-component>
                    </div>

                    <div
                        class="actionplan-options"
                        v-if="data.item.key === 'powerpoint' && data.item.switch_value">
                        <b-button
                            class="btn-file-alt btn-sm btn-primary"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :href="powerpointUrl"
                            target="_blank"
                            :title="$t('group.settings.set_up_text')">
                        </b-button>

                        <b-button
                            class="btn-upload"
                            v-b-modal="'paper-powerpoint-upload-modal'"
                            variant="primary-icon-only">
                        </b-button>
                        <design-2021-group-show-upload-powerpoint-blueprint-modal-component :id="groupIn.id">
                        </design-2021-group-show-upload-powerpoint-blueprint-modal-component>
                    </div>

                    <div
                        class="roadmap-options"
                        v-if="data.item.key === 'roadmap' && data.item.switch_value">
                        <design-2021-group-select-roadmap-component
                            :group-in="groupIn"
                            :roadmaps-in="roadmapsIn"></design-2021-group-select-roadmap-component>
                    </div>

                    <div
                        class="rating-options"
                        v-if="data.item.key === 'rating' && data.item.switch_value">
                        <b-button
                            class="btn-management"
                            variant="primary"
                            @click="showRatingModal">
                            {{ $t('common.edit') }}
                        </b-button>
                        <design-2021-group-show-rating-modal-component
                            :group-in="groupIn"
                            :ratings-in="ratingsIn"
                            ref="groupShowRatingModal">
                        </design-2021-group-show-rating-modal-component>

                        <design-2021-group-show-rating-modal-new-form-component @input="storeNewRatingForm">
                        </design-2021-group-show-rating-modal-new-form-component>
                    </div>

                    <div
                        class="questionnaire-options"
                        v-if="data.item.key === 'questionnaire' && data.item.switch_value">
                        <design-2021-group-select-questionnaire-component
                            :group-in="groupIn"
                            :questionnaires-in="questionnairesIn">
                        </design-2021-group-select-questionnaire-component>
                    </div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-options-component',
    props: ['groupIn', 'roadmapsIn', 'ratingsIn', 'groupOptionsAvailability', 'questionnairesIn'],
    data() {
        return {
            awaitingSearch: false,
            optionsFields: [
                {
                    key: 'option',
                    label: this.$t('common.edit'),
                },
                {
                    key: 'custom_name',
                    label: this.$t('group.settings.own_name'),
                },
                {
                    key: 'toggle',
                    label: this.$t('group.settings.on_off'),
                },
                {
                    key: 'choice',
                    label: this.$t('group.settings.choice'),
                },
            ],
            selectedChoice: 0,
            choiceOptions: [
                { value: 0, text: this.$t('group.settings.choose_roadmap') },
                { value: 1, text: this.$t('group.settings.roadmap') },
            ],
            editor_type: '',
        };
    },
    computed: {
        optionItems() {
            let items = [];

            if (![2, 7].includes(this.groupIn.type_id)) {
                items.push({
                    option: this.$t('group.settings.edit_title'),
                    key: 'edittitle',
                    switch_value: !!this.groupIn.edittitle,
                    disabled: !this.groupOptionsAvailability.edittitle || !!this.groupIn.parent_id,
                });
            }
            if (this.groupIn.type_id !== 2) {
                items.push({
                    option: this.$t('group.settings.choose_courses'),
                    key: 'addcourses',
                    switch_value: !!this.groupIn.addcourses,
                    disabled: !this.groupOptionsAvailability.addcourses || !!this.groupIn.parent_id,
                });
            }
            if (this.groupIn.type_id !== 2) {
                items.push({
                    option: this.$t('group.settings.paper'),
                    custom_name: this.groupIn.document_name
                        ? this.groupIn.document_name
                        : this.$t('group.settings.paper'),
                    custom_name_disabled: !!this.groupIn.parent_id,
                    key: 'document',
                    switch_value: !!this.groupIn.document,
                    hasChoice: true,
                    disabled: true,
                });
            }
            if (this.groupIn.type_id !== 2) {
                items.push({
                    option: this.$t('group.settings.action_plan'),
                    custom_name: this.groupIn.actionplan_name
                        ? this.groupIn.actionplan_name
                        : this.$t('group.settings.action_plan'),
                    custom_name_disabled: !!this.groupIn.parent_id,
                    key: 'actionplan',
                    switch_value: !!this.groupIn.actionplan,
                    hasChoice: true,
                    disabled: !this.groupOptionsAvailability.actionplan || !!this.groupIn.parent_id,
                });
            }

            items.push({
                option: 'Magazine',
                custom_name: this.groupIn.magazine_name ? this.groupIn.magazine_name : 'Magazine',
                custom_name_disabled: !!this.groupIn.parent_id,
                key: 'magazine',
                switch_value: !!this.groupIn.magazine,
                disabled: !this.groupOptionsAvailability.magazine || !!this.groupIn.parent_id,
            });

            if (this.groupIn.type_id !== 2) {
                items.push({
                    option: 'Powerpoint',
                    custom_name: this.groupIn.powerpoint_name ? this.groupIn.powerpoint_name : 'Powerpoint',
                    custom_name_disabled: !!this.groupIn.parent_id,
                    key: 'powerpoint',
                    switch_value: !!this.groupIn.powerpoint,
                    disabled: !this.groupOptionsAvailability.powerpoint || !!this.groupIn.parent_id,
                    hasChoice: true,
                });
            }

            if (this.groupIn.type_id === 1) {
                items.push({
                    option: this.$t('group.settings.additional_files'),
                    key: 'custom_editor_files',
                    switch_value: !!this.groupIn.custom_editor_files,
                    hasChoice: true,
                    disabled: !!this.groupIn.parent_id,
                });
            }

            items.push({
                option: 'Agenda',
                custom_name: this.groupIn.agenda_name ? this.groupIn.agenda_name : 'Agenda',
                custom_name_disabled: !!this.groupIn.parent_id,
                key: 'agenda',
                switch_value: !!this.groupIn.agenda,
                disabled: !this.groupOptionsAvailability.agenda || !!this.groupIn.parent_id,
            });

            items.push({
                option: this.$t('group.settings.messages'),
                custom_name: this.groupIn.messages_name
                    ? this.groupIn.messages_name
                    : this.$t('group.settings.messages'),
                custom_name_disabled: !!this.groupIn.parent_id,
                key: 'messages',
                switch_value: !!this.groupIn.messages,
                disabled: !this.groupOptionsAvailability.messages || !!this.groupIn.parent_id,
            });

            items.push({
                option: this.$t('group.settings.files'),
                custom_name: this.groupIn.files_name ? this.groupIn.files_name : this.$t('group.settings.files'),
                custom_name_disabled: !!this.groupIn.parent_id,
                key: 'files',
                switch_value: !!this.groupIn.files,
                disabled: !this.groupOptionsAvailability.files || !!this.groupIn.parent_id,
            });

            items.push({
                option: this.$t('group.settings.source_list'),
                custom_name: this.groupIn.sourcelist_name
                    ? this.groupIn.sourcelist_name
                    : this.$t('group.settings.source_list'),
                custom_name_disabled: !!this.groupIn.parent_id,
                key: 'sourcelist',
                switch_value: !!this.groupIn.sourcelist,
                disabled: !this.groupOptionsAvailability.sourcelist || !!this.groupIn.parent_id,
            });

            items.push({
                option: this.$t('group.settings.logbook'),
                custom_name: this.groupIn.logbook_name ? this.groupIn.logbook_name : this.$t('group.settings.logbook'),
                custom_name_disabled: !!this.groupIn.parent_id,
                key: 'logbook',
                switch_value: !!this.groupIn.logbook,
                disabled: !this.groupOptionsAvailability.logbook || !!this.groupIn.parent_id,
            });

            if (this.groupIn.type_id !== 2) {
                items.push({
                    option: this.$t('group.settings.plagiarism_report'),
                    custom_name: this.groupIn.plagiarism_name
                        ? this.groupIn.plagiarism_name
                        : this.$t('group.settings.plagiarism_report'),
                    custom_name_disabled: !!this.groupIn.parent_id,
                    key: 'plagiarism',
                    switch_value: !!this.groupIn.plagiarism,
                    disabled: !this.groupOptionsAvailability.plagiarism || !!this.groupIn.parent_id,
                });

                items.push({
                    option: this.$t('group.settings.questionnaire'),
                    custom_name: this.groupIn.questionnaire_name
                        ? this.groupIn.questionnaire_name
                        : this.$t('group.settings.questionnaire'),
                    custom_name_disabled: !!this.groupIn.parent_id,
                    key: 'questionnaire',
                    switch_value: !!this.groupIn.questionnaire,
                    hasChoice: this.groupOptionsAvailability.questionnaire_open,
                    disabled: !this.groupOptionsAvailability.questionnaire,
                });
            }

            items.push({
                option: this.$t('group.settings.roadmap'),
                custom_name: this.groupIn.roadmap_name ? this.groupIn.roadmap_name : this.$t('group.settings.roadmap'),
                custom_name_disabled: !!this.groupIn.parent_id,
                key: 'roadmap',
                switch_value: !!this.groupIn.roadmap,
                hasChoice: this.groupOptionsAvailability.roadmap_open,
                disabled: !this.groupOptionsAvailability.roadmap,
            });

            items.push({
                option: this.$t('group.settings.assessment_form'),
                custom_name: this.groupIn.rating_name
                    ? this.groupIn.rating_name
                    : this.$t('group.settings.assessment_form'),
                custom_name_disabled: !!this.groupIn.parent_id,
                key: 'rating',
                switch_value: !!this.groupIn.rating,
                hasChoice: this.groupOptionsAvailability.rating_open,
                disabled: !this.groupOptionsAvailability.rating,
            });

            return items;
        },

        actionPlanUrl() {
            return this.routes.baseUrl() + this.routes.groupActionPlan(this.groupIn.id);
        },

        editorUrl() {
            return this.routes.baseUrl() + this.routes.groupBluePrintUrl(this.groupIn.id);
        },

        powerpointUrl() {
            return this.routes.baseUrl() + this.routes.groupPowerpoint(this.groupIn.id);
        },
    },
    methods: {
        saveOption(key, value) {
            const data = {
                option: key,
                value: value,
            };

            this.axios.post(this.routes.groupOptionsStatusUpdate(this.groupIn.id), data).then(
                (response) => {
                    this.$emit('groupUpdated', data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        showRatingModal() {
            this.axios.get(this.routes.getRatings(this.groupIn.id)).then(
                (response) => {
                    if (response.data.length === 0) {
                        this.$bvModal.show('create-rating-form-modal');
                    } else {
                        this.$refs['groupShowRatingModal'].show(response.data);
                    }
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        storeNewRatingForm(formData) {
            const data = {
                title: formData,
            };

            this.axios.post(this.routes.ratingCreateForm(this.groupIn.id), data).then(
                (response) => {
                    window.location.href = this.routes.ratingEditForm(response.data.rating_id, this.groupIn.id);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    mounted() {
        if (this.groupIn.editor_type === 'oo') {
            this.editor_type = 'Only Office';
        } else if (this.groupIn.editor_type === 'moo') {
            this.editor_type = 'Microsoft Office Online';
        } else if (this.groupIn.editor_type === 'sp') {
            this.editor_type = 'Office 365';
        } else if (this.groupIn.editor_type === 'gd') {
            this.editor_type = 'Google docs';
        } else if (this.groupIn.editor_type === 'mg') {
            this.editor_type = 'Magazine';
        }
    },
};
</script>

<style scoped lang="scss">
.group-options-table ::v-deep {
    .apprentice-table-filters {
        display: none !important;
    }
}

.choice-wrapper {
    display: flex;
    flex: 1 0 auto;

    .document-options,
    .actionplan-options {
        display: flex;
        align-items: center;

        .btn:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .roadmap-options,
    .questionnaire-options {
        flex: 1 0 auto;
        max-width: 250px;
    }

    button.btn-management {
        &,
        &:before {
            font-size: $base-font-size;
        }
    }

    .rating-options {
        width: 100%;

        .btn-management {
            width: calc(100% - 12px);
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .files-management ::v-deep {
        .group-options-table {
            .apprentice-data-table {
                width: max-content;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .group-options-table ::v-deep {
        .choice-header {
            min-width: 250px;
        }

        tbody {
            tr {
                &:nth-last-child(3),
                &:nth-last-child(2),
                &:nth-last-child(1) {
                    height: 67px;
                }
            }
        }
    }

    .choice-wrapper {
        .rating-options {
            &,
            .btn-management {
                width: auto;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .files-management ::v-deep {
        .group-options-table {
            .apprentice-data-table {
                width: 100%;
            }
        }
    }
}
</style>
